<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img class="image_1" referrerpolicy="no-referrer" :src="topStripImage" />
      <div class="box_1 flex-col">
        <div class="text-wrapper_1 flex-col" :style="heroBgStyle">
          <span class="text_8">{{ pageTitle }}</span>
        </div>
        <div class="text-wrapper_2">
          <span class="text_9">
            <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
            &nbsp;&gt;&nbsp;
            <router-link :to="sectionRoute" style="color: inherit; text-decoration: none;">{{ sectionLabel }}</router-link>
            &nbsp;&gt;&nbsp;
          </span>
          <span class="text_10">{{ pageTitle }}</span>
        </div>
        <div class="box_3 flex-col">
          <div class="text-wrapper_4 flex-col"><span class="text_19">{{ pageTitle }}</span></div>
          <div class="web-content">
            <slot></slot>
          </div>
        </div>
        <SiteFooter :notch-width="1300" notch-left="calc((100vw - 1300px) / 2)" />
      </div>
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'WebChapterTemplate',
  components: {
    SiteHeader,
    SiteFooter
  },
  props: {
    pageTitle: { type: String, required: true },
    sectionLabel: { type: String, required: true },
    sectionRoute: { type: [String, Object], default: '/lanhu_chuanboyupingtai' },
    topStripImage: { type: String, required: true },
    heroBackgroundImage: { type: String, required: true }
  },
  computed: {
    heroBgStyle() {
      const rawUrl = this.heroBackgroundImage || '';
      if (!rawUrl) return {};
      const isAbsolute =
        /^(?:[a-z]+:)?\/\//i.test(rawUrl) ||
        rawUrl.startsWith('/') ||
        rawUrl.startsWith('data:') ||
        rawUrl.startsWith('blob:');
      const baseUrl = process.env.BASE_URL || '/';
      const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
      const normalizedRaw = rawUrl.startsWith('./') ? rawUrl.slice(2) : rawUrl;
      const resolvedUrl = isAbsolute ? rawUrl : `${normalizedBase}${normalizedRaw}`;
      return { '--hero-bg-image': `url(${resolvedUrl})` };
    }
  }
};
</script>

<style scoped>
.page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  padding: 0 0 82px;
}

.image_1 {
  width: 1300px;
  height: 39px;
  display: none;
}

.box_1 {
  background-color: #fff;
  position: relative;
  width: 100%;
  min-height: auto;
  margin: 0;
  box-sizing: border-box;
}

.text-wrapper_1 {
  position: relative;
  box-sizing: border-box;
  padding: 96px max(24px, calc((100% - 1300px) / 2)) 14px;
}

.text-wrapper_1::before {
  content: '';
  position: absolute;
  inset: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  background-image: var(--hero-bg-image);
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 51px 0 rgba(0, 0, 0, 0.81);
  z-index: 0;
}

.text-wrapper_1 > * {
  position: relative;
  z-index: 1;
}

.text_8 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 48px;
  letter-spacing: 0.64px;
  font-family: SourceHanSerifCN-SemiBold;
  text-align: left;
  white-space: nowrap;
  line-height: 69px;
}

.text-wrapper_2 {
  width: min(1300px, 100%);
  min-height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  letter-spacing: 0.2133333384990692px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 18px auto 0;
  padding: 0;
  box-sizing: border-box;
}

.text_9 {
  color: rgba(225, 96, 31, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  line-height: 24px;
}

.text_10 {
  color: rgba(225, 96, 31, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Light;
  font-weight: 300;
  line-height: 24px;
}

.box_3 {
  background-color: rgba(255, 255, 255, 1);
  width: min(1300px, 100%);
  align-self: stretch;
  margin: 16px auto 0;
  padding: 15px 0 44px;
  box-sizing: border-box;
}

.text-wrapper_4 {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.03);
  background-color: rgba(225, 96, 31, 1);
  width: 100%;
  margin-left: 0;
  padding: 7px 20px 8px;
  box-sizing: border-box;
}

.text_19 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  letter-spacing: 0.3466666638851166px;
  font-family: SourceHanSerifCN-SemiBold;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
}

/* ===== Web Content Slot ===== */

.web-content {
  width: 100%;
  margin: 24px 0 0;
  padding: 0 20px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .page {
    overflow-x: hidden;
  }

  .box_1 {
    width: 100%;
    min-height: auto;
    padding: 0 16px 40px;
  }

  .text-wrapper_1 {
    width: 100%;
    margin: 0;
    padding: 90px 16px 24px;
  }

  .text-wrapper_2 {
    width: 100%;
    margin: 16px 0 0;
    white-space: normal;
  }

  .text_8 {
    font-size: 28px;
    line-height: 36px;
    white-space: normal;
  }

  .box_3 {
    width: 100%;
    margin-top: 16px;
    padding: 0 0 24px;
  }

  .text-wrapper_4 {
    width: 100%;
    margin: 0;
    padding: 10px 16px;
  }

  .web-content {
    padding: 0 12px;
  }
}
</style>
